import { render, staticRenderFns } from "./EscalarTime.vue?vue&type=template&id=70e07920&scoped=true&"
import script from "./EscalarTime.vue?vue&type=script&lang=js&"
export * from "./EscalarTime.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70e07920",
  null
  
)

export default component.exports